import { defineMessages } from 'react-intl'

export const consentMessages = defineMessages({
  saveError: {
    defaultMessage: 'Your choices could not be saved. Please allow site cookies and try again.',
    id: 'crUAi5v6dyPgNLcRBm0U',
    description: 'Error shown when browser restrictions prevent saving a cookie consent choice so the customer can retry',
  },
  continueNecessary: {
    defaultMessage: 'Continue without optional cookies',
    id: '_npG6O1uUabJxhorA8lD',
    description: 'Button to continue this page with optional tracking disabled when an initial consent choice cannot be saved',
  },
  dialogLabel: {
    id: 'P0ir3RTrAJzOUMg1Gauo',
    defaultMessage: 'Cookie settings',
    description: 'Accessible name for the cookie consent dialog that controls optional tracking purposes',
  },
  heading: {
    id: '5a2ZHhtv0iN9RmgfYVKR',
    defaultMessage: 'Your privacy, your choice',
    description: 'Heading shown on the first layer of the cookie consent modal before a customer chooses optional tracking',
  },
  responsibleParty: {
    id: 'XyMdQXAXDjhELSsdLd3c',
    defaultMessage: 'Luxury Escapes Travel Pty Ltd ACN 150 650 927 is responsible for your personal data on this site. We use necessary cookies and similar technologies to keep the site secure and working.',
    description: 'First-layer cookie consent copy identifying the data controller and explaining necessary cookies',
  },
  optionalUse: {
    id: 'zblSHy8PwrID14HdDz3N',
    defaultMessage: 'With your permission, we and our partners use optional cookies to understand site performance, personalise your experience, test improvements and measure advertising.',
    description: 'First-layer cookie consent copy explaining optional analytics, personalisation, experimentation and advertising cookies',
  },
  changeOrWithdraw: {
    id: 'Uvygt0907-yuIFPEeynS',
    defaultMessage: 'You can choose what works for you. You can change or withdraw your choices at any time in Cookie settings.',
    description: 'First-layer cookie consent copy telling customers they can change or withdraw optional cookie choices later',
  },
  cookiePolicy: {
    id: 'bgdXDtinCKL4C-LO6J_9',
    defaultMessage: 'Cookie Policy',
    description: 'Link text in the cookie consent modal that opens the localised cookie policy document',
  },
  cookieSettings: {
    id: 'H6ZDMrjRdRRkZC4TluoJ',
    defaultMessage: 'Cookie settings',
    description: 'Header or footer link and configure-view title that reopens cookie choices so customers can change or withdraw consent',
  },
  necessaryTitle: {
    id: 'Bn35m0ETZ8bM2CKwy3Ub',
    defaultMessage: 'Necessary cookies',
    description: 'Label for the always-on necessary cookies row in the cookie consent configure view',
  },
  necessaryDescription: {
    id: 'sbo9gBTgEz8S6C_652vy',
    defaultMessage: 'Always on. Keep the site secure, remember your session and enable features such as signing in and saving your cart.',
    description: 'Explanation that necessary cookies cannot be switched off and support security, session and cart features',
  },
  analytics: {
    id: 'NgBJ-vEdvNXc8-c0_h-Z',
    defaultMessage: 'Analytics',
    description: 'Toggle label for the optional analytics cookie purpose in the consent configure view',
  },
  analyticsDescription: {
    id: 'yBn8nIhWVUfoU50tqOPN',
    defaultMessage: 'Help us understand how the site performs and improve it.',
    description: 'Explanation of the optional analytics cookie purpose shown beside its toggle in cookie settings',
  },
  personalisation: {
    id: 'bPJ2lWFlstztDo4dBchO',
    defaultMessage: 'Personalisation',
    description: 'Toggle label for the optional personalisation cookie purpose in the consent configure view',
  },
  personalisationDescription: {
    id: '0XjPzXUJ5XEA1GYK4kl3',
    defaultMessage: 'Use your activity and preferences to make the content you see more relevant.',
    description: 'Explanation of the optional personalisation cookie purpose shown beside its toggle in cookie settings',
  },
  experimentation: {
    id: 'aAcXE1FJL-N4LO4BNijm',
    defaultMessage: 'Experimentation',
    description: 'Toggle label for the optional experimentation cookie purpose in the consent configure view',
  },
  experimentationDescription: {
    id: 'smZhttAj-I2HX9568uUZ',
    defaultMessage: 'Together with analytics, help us test improvements to the site experience. Both choices must be enabled to take part.',
    description: 'Explanation of the optional experimentation cookie purpose shown beside its toggle in cookie settings',
  },
  advertising: {
    id: 'dMOeQha5cjaSOJintIMS',
    defaultMessage: 'Advertising',
    description: 'Toggle label for the optional advertising cookie purpose in the consent configure view',
  },
  advertisingDescription: {
    id: 'eLQUMQXn-tNy_q6Ae5nx',
    defaultMessage: 'Allow us and our advertising partners to measure our advertising and show you more relevant ads on other sites and apps. This involves sharing data with those partners.',
    description: 'Explanation of the optional advertising cookie purpose and partner data sharing in cookie settings',
  },
  acceptAll: {
    id: 'z575AVqSBQMz6zYMIc8Y',
    defaultMessage: 'Accept all',
    description: 'Equal-prominence button that grants every optional cookie purpose in the consent dialog',
  },
  necessaryOnly: {
    id: 'ASN-kKqGksaxH6K_qfn_',
    defaultMessage: 'Necessary cookies only',
    description: 'Equal-prominence button that refuses every optional cookie purpose in the consent dialog',
  },
  configure: {
    id: 'Uie2oPdgbN0aXegfplEp',
    defaultMessage: 'Configure',
    description: 'Equal-prominence button that opens granular optional cookie purpose choices in the consent dialog',
  },
  saveChoices: {
    id: 'glsHGujAkFmSyssn5ykC',
    defaultMessage: 'Save choices',
    description: 'Sticky footer button that saves the optional cookie purpose selections made in the configure view',
  },
  savedConfirmation: {
    id: 'GHyB357odJS3RVoko8mM',
    defaultMessage: 'Your cookie choices have been saved. You can review or change them at any time in Cookie settings.',
    description: 'Confirmation shown after cookie choices are saved explaining they can be reviewed in Cookie settings',
  },
  gotIt: {
    id: 'pHYwqWFUczaYcjf3MS5r',
    defaultMessage: 'Got it',
    description: 'Button that dismisses the cookie consent confirmation and reloads the page to apply the saved choices',
  },
  applyingChoices: {
    id: 'rpPDnbBmboFvECyMMAWW',
    defaultMessage: 'Applying your cookie choices',
    description: 'Loading status announced while the page reloads to apply a newly saved cookie consent decision',
  },
})
